<template>
    <div class="SizeImg">
           <div class="Size_img">
                   <h1>裤子尺码对照表</h1>
                 <img src="./img/SizeImg/02f2862a89197fd17d6d937e9d258222ca.png" alt="">
                 <img src="./img/SizeImg/0202f5251f7f424649f638ced44016ff55.png" alt="">
                  <h1>鞋子尺码对照表</h1>
                 <img src="./img/SizeImg/01c7bbd180b67e69cb8a39a9d4042c5bf1.png" alt="">
                 <img src="./img/SizeImg/01cc2ef4c83cd94c1c2c7b3337af2fff0f.png" alt=""> 
                 <h1>衬衫尺码对照表</h1>
                 <img src="./img/SizeImg/028edc5bf1b2087ad71b6bfa093bced7cc.png" alt="">
                 <img src="./img/SizeImg/0147f0a0e8c269d6fa4976bb9d3edd3902.png" alt="">
           </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            
        }
    }
}
</script>

<style>
  .Size_img{
        width: 100%;
        height: 100%;
        /* display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center; */
        margin: 100px auto;
  }
  .Size_img{
        border: 1px dotted #888;
        width: 80%;
        height: 100%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        padding: 30px;
        box-sizing: border-box;
  }
  .Size_img h1{
      margin: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/footer/SizeImg.vue